import serverUrl from "api/ServerUrl";

const ORGANIZATIONS_URL = `${serverUrl}organizations`;
const SEARCH_ORGANIZATIONS_ALPHA_URL = `${serverUrl}search_alpha_organization`;
const SEARCH_ORGANIZATIONS_NUMERIC_URL = `${serverUrl}search_numaric_organization`;

export default {
  SEARCH_ORGANIZATIONS_ALPHA_URL,
  SEARCH_ORGANIZATIONS_NUMERIC_URL,
  ORGANIZATIONS_URL,
};
